export default "__VITE_ASSET__CrdLHBJ___"